import { publicClient, privateClient } from './client';
import { Event } from './Event';

const transactionsEvent = (pub: boolean) => new Event(pub ? publicClient : privateClient);
export default transactionsEvent;
